import React from 'react'
import { Card, Box, Skeleton } from '@mui/material'

export const BookingsSkeleton: React.FC = () => {
  return (
    <Card sx={{ borderRadius: 3, p: { xs: 2, sm: 3 } }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          gap: 2,
          mb: 3,
        }}
      >
        <Skeleton variant="rounded" width={180} height={36} sx={{ borderRadius: 1.5, width: { xs: '100%', sm: 180 } }} />
        <Skeleton variant="rounded" width={140} height={36} sx={{ borderRadius: 1.5, width: { xs: '100%', sm: 140 } }} />
      </Box>
      <Skeleton variant="rounded" height={400} sx={{ borderRadius: 2, height: { xs: 320, sm: 480 } }} />
    </Card>
  )
}

export default BookingsSkeleton
